// Default state for the finalize object
export default () => ({
    open: 'form', // the current open step in the checkout process
    form: 'uncompleted',
    scheduler: 'uncompleted',
    selfInstall: 'uncompleted',
})